import { render } from "./ModalTableShow.vue?vue&type=template&id=7c353e14"
import script from "./ModalTableShow.vue?vue&type=script&lang=js"
export * from "./ModalTableShow.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__